// src/api/useNotifications.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

// ✅ Base URL for notifications API
const BASE_URL = `${API_BASE_PATH}/notifications`;

// ✅ Notification Interface
export interface Notification {
  id: number;
  is_read: boolean;
  user_id: string;
  message: string;
  created_at: string;
}

// ✅ Fetch notifications by user ID
export const fetchNotificationsByUserId = async (
  userId: string
): Promise<Notification[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/${userId}`, {
      headers: {
        accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch notifications");
    throw console.log(error);
  }
};
export const markNotificationAsRead = async (notificationId: number) => {
  try {
    await axios.put(`${BASE_URL}/${notificationId}/read`, {
      headers: { accept: "application/json" },
    });
  } catch (err) {
    console.error("Failed to mark notification as read", err);
    throw err;
  }
};

export const markNotificationsAsRead = async (
  notificationIds: number | number[]
) => {
  // Ensure we have an array
  const idsArray = Array.isArray(notificationIds)
    ? notificationIds
    : [notificationIds];

  if (idsArray.length === 0) return;

  const url = `${BASE_URL}/read?notification_ids=${idsArray.join(",")}`;

  try {
    await axios.put(url, null, {
      headers: { accept: "application/json" },
    });
  } catch (err) {
    console.error("Failed to mark notifications as read", err);
    throw err;
  }
};

